import type { ReactNode } from 'react';
import type { AlertGroup, IAlertSettingRow, IAlertSettingsGroup } from '@d-orca/shared/alert-kinds';
import { AlertGroupCard } from './AlertGroupCard';
import { AlertRow, type IAlertRowProps } from './AlertRow';
import styles from './AlertSettingsList.module.css';

export interface IAlertSettingsListProps {
  /** As the server lists them: groups in display order, rows already cut for the caller. */
  groups: IAlertSettingsGroup[];
  /** What each row is wired to on this page. */
  rowProps: (row: IAlertSettingRow, group: AlertGroup) => Omit<IAlertRowProps, 'row'>;
  groupAction?: (group: AlertGroup) => ReactNode;
}

/** The settings, one card per group — the body both settings pages share. */
export function AlertSettingsList({ groups, rowProps, groupAction }: IAlertSettingsListProps) {
  return (
    <div className={styles.list}>
      {groups.map(({ group, rows }) => (
        <AlertGroupCard key={group} group={group} action={groupAction?.(group)}>
          {rows.map((row) => (
            <AlertRow key={row.key} row={row} {...rowProps(row, group)} />
          ))}
        </AlertGroupCard>
      ))}
    </div>
  );
}
